import dynamic from 'next/dynamic';

import { Otovo$Config } from '@otovo/shared/types/otovoweb';
import { Sanity$Document } from '@otovo/shared/types/sanityTypes';

import StorefrontPage from '../StorefrontPage';

const NavbarLogo = dynamic(() => import('./Navbar/NavbarLogo'));
const StorefrontNav = dynamic(() => import('./Navbar/Navbar'));

type Props = {
  children: React.ReactNode;
  config: Otovo$Config;
  hideMenu?: boolean;
  hideFooter?: boolean;
  sanityDocument?: Sanity$Document;
};

const StorefrontPageV2 = (props: Props) => {
  const { children, config, hideFooter, hideMenu, sanityDocument } = props;
  const navbarConfig = config.navbar;

  return (
    <StorefrontPage
      config={config}
      hideFooter={hideFooter}
      hideMenu={hideMenu}
      sanityDocument={sanityDocument}
      menuRenderer={() => {
        if (navbarConfig) {
          return (
            <StorefrontNav
              sanityDocument={sanityDocument}
              navbarConfig={navbarConfig}
            />
          );
        }
        return null;
      }}
    >
      {hideMenu && (
        <div className="relative z-50 w-full max-w-8xl px-2 sm:px-14 md:px-16 2xl:mx-auto">
          <div className="absolute my-3 md:my-4">
            <NavbarLogo linkToRoot={false} variant="white" />
          </div>
        </div>
      )}
      {children}
    </StorefrontPage>
  );
};

export default StorefrontPageV2;
